import { render, staticRenderFns } from "./TestTableau.vue?vue&type=template&id=0416cc5e"
import script from "./TestTableau.vue?vue&type=script&lang=js"
export * from "./TestTableau.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports